class WifiOverride {
  normalize = (override) => {
    // Backend returns 'latitude'/'longitude' as strings
    const lat = override.lat || override.latitude;
    const lng = override.lng || override.longitude;
    
    return {
      bssid: override.bssid || '',
      lat: lat ? Number(lat) : 0,
      lng: lng ? Number(lng) : 0,
      updatedAt: override.updatedAt || override.updated_at || new Date().toISOString(),
      orgId: override.orgId || override.org_id || null,
    };
  };
}

export default WifiOverride;